"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TokenPairSchema", {
    enumerable: true,
    get: function() {
        return TokenPairSchema;
    }
});
const _zod = require("zod");
const TokenPairSchema = _zod.z.object({
    accessToken: _zod.z.string().min(1),
    refreshToken: _zod.z.string().min(1),
    expiresIn: _zod.z.number().int().positive()
});
